import React from 'react';
import { CalendarHeaderSC, clsPrefix } from './calendar-header.styled';
import classNames from 'classnames';

interface CalendarHeaderProps {
  left?: React.ReactNode;
  children?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}

const CalendarHeader: React.FunctionComponent<CalendarHeaderProps> = ({
  children,
  left,
  right,
  className,
}) => {
  return (
    <CalendarHeaderSC className={classNames(className, clsPrefix)}>
      <div className={`${clsPrefix}__left`}>{left}</div>
      <div className={`${clsPrefix}__title`}>{children}</div>
      <div className={`${clsPrefix}__right`}>{right}</div>
    </CalendarHeaderSC>
  );
};

export default CalendarHeader;
